<ion-content>
  <ion-grid>

    <ion-row>
      <ion-col size="12">
        <ion-icon name="notifications" color="primary"></ion-icon>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col size="12">
        <ion-text color="dark" class="ion-text-center">
          <h5><b>{{'Please allow notifications for inform you about your requests.' | translate}}</b></h5>
        </ion-text>
      </ion-col>
    </ion-row>

    <ion-row>
      <ion-col size="12">
        <ion-button (click)="accept()" expand="block" color="primary">
          {{'Allow' | translate}}
        </ion-button>
      </ion-col>

      <ion-col size="12">
        <ion-button (click)="close()" expand="block" color="primary" fill="clear">
          {{'Deny' | translate}}
        </ion-button>
      </ion-col>
    </ion-row>


  </ion-grid>
</ion-content>